import { Post } from '@/@types/post'
import { useSearch } from '@tanstack/react-router'
import usePost from './usePost'
import useUniversalNavigate from './useUniversalNavigate'

export default function usePostDrawer(): {
	data: Post | undefined
	isOpen: boolean
	close: () => void
} {
	const { id } = useSearch({ strict: false }) as {
		id: string | undefined
	}
	const navigate = useUniversalNavigate()

	const post = usePost(id)

	return {
		data: post,
		isOpen: !!id,
		close: () => {
			navigate({
				search: ({ id: _id, ...next }) => next,
			})
		},
	}
}
